module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "management"
  }, [_c('h1', [_vm._v("Create User")]), _vm._v(" "), _c('form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "action": "#"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-element"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.username),
      expression: "formInfo.username"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "First Name",
      "data-vv-as": "\"First Name\"",
      "placeholder": "First Name"
    },
    domProps: {
      "value": (_vm.formInfo.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formInfo, "username", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('First Name')) ? _c('div', {
    staticClass: "form-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('First Name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.lastName),
      expression: "formInfo.lastName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Last Name",
      "data-vv-as": "\"Last Name\"",
      "placeholder": "Last Name"
    },
    domProps: {
      "value": (_vm.formInfo.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formInfo, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('Last Name')) ? _c('div', {
    staticClass: "form-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('Last Name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.email),
      expression: "formInfo.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "Email Address",
      "data-vv-as": "\"Email Address\"",
      "placeholder": "Email Address"
    },
    domProps: {
      "value": (_vm.formInfo.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formInfo, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('Email Address')) ? _c('div', {
    staticClass: "form-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('Email Address')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.plainPassword.first),
      expression: "formInfo.plainPassword.first"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "PasswordFirst",
      "data-vv-as": "\"PasswordFirst\"",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.formInfo.plainPassword.first)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formInfo.plainPassword, "first", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('PasswordFirst')) ? _c('div', {
    staticClass: "form-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('PasswordFirst')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.plainPassword.second),
      expression: "formInfo.plainPassword.second"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:PasswordFirst'),
      expression: "'required|confirmed:PasswordFirst'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "PasswordSecond",
      "data-vv-as": "\"PasswordSecond\"",
      "placeholder": "Confirm Password"
    },
    domProps: {
      "value": (_vm.formInfo.plainPassword.second)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formInfo.plainPassword, "second", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('PasswordSecond')) ? _c('div', {
    staticClass: "form-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('PasswordSecond')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control--select",
    attrs: {
      "placeholder": "Function",
      "name": "Function",
      "data-vv-name": "Function",
      "data-vv-as": "\"Function\"",
      "options": _vm.functionOptions
    },
    model: {
      value: (_vm.formInfo.function),
      callback: function($$v) {
        _vm.$set(_vm.formInfo, "function", $$v)
      },
      expression: "formInfo.function"
    }
  }), _vm._v(" "), (_vm.errors.has('Function')) ? _c('div', {
    staticClass: "form-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('Function')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control--select",
    attrs: {
      "placeholder": "User Role",
      "name": "userRole",
      "data-vv-name": "userRole",
      "data-vv-as": "\"userRole\"",
      "options": _vm.getRolesForSelect
    },
    model: {
      value: (_vm.userRole),
      callback: function($$v) {
        _vm.userRole = $$v
      },
      expression: "userRole"
    }
  }), _vm._v(" "), (_vm.errors.has('userRole')) ? _c('div', {
    staticClass: "form-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('userRole')))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-element"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formInfo.jobTitle),
      expression: "formInfo.jobTitle"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Job Title",
      "data-vv-as": "\"Job Title\"",
      "placeholder": "Job Title"
    },
    domProps: {
      "value": (_vm.formInfo.jobTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formInfo, "jobTitle", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.has('Job Title')) ? _c('div', {
    staticClass: "form-errors"
  }, [_vm._v(_vm._s(_vm.errors.first('Job Title')))]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "form-control form-submit",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create User")]), _vm._v(" "), _c('form-messages', {
    attrs: {
      "messages": _vm.formServerMessages
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-666d821a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Admin/Management.vue
// module id = 1013
// module chunks = 0